<template>
  <div class="MonthTicketDialog">
    <van-popup v-model="showDialog" :close-on-click-overlay="false">
      <div >
        <div class="back-img">
          <img src="../../assets/images/hisTrack/monthticket-back.png" alt="">
        </div>
        <div class="content">
          <div class="title">本月免费到账<span class="highlight">5票</span></div>
          <div class="flex next-box highlight" >
            下次赠票时间: <span >{{ nextMonth }}</span>
          </div>
          <div class="careful">注：下载APP，每月赠送<span>10票</span></div>
          <div class="btn flex" @click="closeDialog">确定</div>
        </div>
      </div>
    </van-popup>
    <!-- <div class="close-icon" v-if="showDialog" style="z-index: 3000" @click="showDialog=false">
      <img src="../../assets/images/hisTrack/close-monthticket-icon.png" alt="" srcset="">
    </div> -->
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapMutations } from 'vuex'
import { setItem, getItem } from '@/utils'
export default {
  props: {},
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {
    ...mapState(['userInfo', 'vip_home_dialog_index']),
    nextMonth () {
      return moment().add(1, 'months').date(1).format('M') + '月' + '1日'
    }
  },
  methods: {
    ...mapMutations({
      updateDialogIndex: 'updateStateData'
    }),
    init() {
      const date = moment().format('YYYY-MM')
      const nextMonth = getItem('nextMonth') || null
      const { hasFreeUpdate = null } = this.userInfo
      this.showDialog = date === nextMonth && hasFreeUpdate
      if (this.showDialog) {
        setItem('nextMonth', moment().add(1, 'months').date(1).format('YYYY-MM'))
        return
      }
      let { vip_home_dialog_index } = this
      vip_home_dialog_index++
      this.updateDialogIndex({
        key: 'vip_home_dialog_index',
        value: vip_home_dialog_index
      })
    },
    showPopup () {
      this.showDialog = true
      setItem('nextMonth', moment().add(1, 'months').date(1).format('YYYY-MM'))
    },
    closeDialog () {
      this.showDialog = false
      this.$emit('close')
    }
  }
};
</script>

<style scoped lang="scss">
.MonthTicketDialog>:first-child {
  background-color: rgba(0,0,0,.4)
}
.MonthTicketDialog>:nth-child(2){
  width: 80%;
  border-radius: 12px;
}
.MonthTicketDialog {
  .back-img {
    img {
      width: 100%;
    }
  }
  .highlight{
    color: #FF9807
  }
  .content {
    padding: 0 40px;
    background-color: #ffffff;
    .title {
      text-align: center;
      font-size: 50px;
      color: #282828;
    }
    .next-box {
      align-items: center;
      padding: 20px 0;
      padding-bottom: 10px;
      justify-content: center;
      span {
        padding-left: 20px;
      }
    }
    .careful {
      text-align: center;
    }
    .btn {
      margin: 60px auto;
      width: 80%;
      background-color: #5572FD;
      border-radius: 40px;
      justify-content: center;
      align-items: center;
      height: 80px;
      font-size: 36px;
      color: #ffffff;
    }
  }
  .close-icon {
      position: fixed;
      bottom: 80px;
      left: 50%;
      margin-left: -40px;
      z-index: 3000;
      text-align: center;
      img {
        width: 80px;
      }
  }
}
</style>
